export const documentStatusColor = (status: string): string => {
  switch (status) {
    case 'not_uploaded':
      return 'warning';
    case 'accepted':
      return 'success';
    case 'rejected':
      return 'error';
    default:
      return '';
  }
};